import SEOLocaleList from '@apps/components/SEOLocaleList';
import { BASE_URL } from '@apps/config';
import {
  getAllBrandsInitial,
  getCarByBrand,
} from '@apps/config/API/new-car.config';
import NewCarScreen from '@apps/screens/NewCar';
import { NextPage, NextPageContext } from 'next';
import { useRouter } from 'next/router';
import { NextSeo, NextSeoProps } from 'next-seo';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const Page: NextPage = (props) => {
  const { data, settings, list, webView } = props;
  // ======================= HOOKS
  const router = useRouter();
  // const { t } = useTranslation('common');
  // ======================= STATE

  // ======================= VARIABLES
  const carBrandSlug = router?.query?.slug;
  const currentUrl = `${BASE_URL}${router?.asPath}`;
  const canonicalPath = currentUrl.split('?')[0].toLowerCase();
  const carBrand = data.all_brand;
  const newCarModels = list?.data?.all_car_model?.data;
  const newCarEV = list.ev_car_models;
  const popularCar = data.popular_car_models;
  const popularBrand = settings.car_brand_featured;
  const carBrandName =
    carBrand?.find((item: any) => item?.car_brand_slug === carBrandSlug)
      ?.car_brand_name || '';
  const nextSeoProps: NextSeoProps = {
    defaultTitle: `${carBrandName} Cars in Malaysia: Current & New Models, Specs & Prices | Carz Automedia Malaysia`,
    description: `Discover the latest ${carBrandName} cars available in Malaysia, including detailed specifications, reviews, pricing, and upcoming models. Find your perfect ${carBrandName} vehicle today with Carz Automedia Malaysia.`,
    canonical: canonicalPath,
  };

  // ======================= VIEWS
  return (
    <>
      {!webView && <NextSeo {...nextSeoProps} />}
      <SEOLocaleList />
      <NewCarScreen
        carBrand={carBrand}
        newCarModels={newCarModels}
        newCarEV={newCarEV}
        popularCar={popularCar}
        popularBrand={popularBrand}
        webView={webView}
      />
    </>
  );
};

/**
 * ===========================
 * SERVER SIDE RENDERING
 * ===========================
 */
export async function getServerSideProps(ctx: NextPageContext) {
  const slug = ctx.query?.slug;
  const results = await getAllBrandsInitial();
  let dataList = [];
  if (slug) {
    dataList = await getCarByBrand({ brand: slug as string });
  }
  return {
    props: {
      data: results,
      list: dataList,
    },
  };
}

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default Page;
